import http from '../core/HttpClient';
import { insertParams } from '../core/actionHelpers';

export function getConversation(conversationId, params, reqParams) {
  const url = insertParams(`/api/messages/${conversationId}?page_size=5`, params);
  return {
    type: 'GET_CONVERSATION',
    conversationId,
    promise: http.get(url, reqParams),
  };
}

export function sendMessageToConversation(conversationId, data) {
  return {
    type: 'SEND_MESSAGE_TO_CONVERSATION',
    conversationId,
    promise: http.post(`/api/messages/${conversationId}?action_type=send`, data),
  };
}

export function sendMessageToUser(userId, data) {
  return {
    type: 'SEND_MESSAGE_TO_USER',
    userId,
    promise: http.post(`/api/messages/direct/${userId}`, data),
  };
}

export function resetPaging() {
  return {
    type: 'RESET_CONVERSATION_PAGING',
  };
}

export function resetConversation() {
  return {
    type: 'RESET_CONVERSATION',
  };
}

export function showConversation(conversationId, recipient) {
  return {
    type: 'SHOW_CONVERSATION',
    conversationId,
    recipient,
  };
}

export function hideConversation() {
  return {
    type: 'HIDE_CONVERSATION',
  };
}



// WEBPACK FOOTER //
// ./src/actions/ConversationActions.js